import type { QueryClient } from "@tanstack/react-query";
import { createRootRouteWithContext, Link, Outlet } from "@tanstack/react-router";
import { Button } from "@/components/ui/button";
import { Toaster } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { sessionQuery } from "@/features/auth/session";

interface RouterContext {
  queryClient: QueryClient;
}

export const Route = createRootRouteWithContext<RouterContext>()({
  // The signed-in user is resolved once here and available to every route guard as context.user.
  beforeLoad: async ({ context }) => ({
    user: await context.queryClient.ensureQueryData(sessionQuery()),
  }),
  component: RootLayout,
  notFoundComponent: () => (
    <div className="flex h-dvh flex-col items-center justify-center gap-3 text-center">
      <p className="text-lg font-medium">Page not found</p>
      <Button asChild variant="outline">
        <Link to="/">Back to roadmaps</Link>
      </Button>
    </div>
  ),
});

function RootLayout() {
  return (
    <TooltipProvider delayDuration={400}>
      <div className="h-dvh w-full overflow-hidden bg-background text-foreground">
        <Outlet />
      </div>
      <Toaster position="bottom-center" richColors closeButton />
    </TooltipProvider>
  );
}
